import React, { Component } from 'react';
import './App.css';
import Sidebar from './components/sidebar'
import Introduction from './components/introduction'
import About from './components/about'
import Testtools from './components/testtools'
import Robot from './components/robot'

class App extends Component {
  render() {
    return (
      <div id="colorlib-page">
        <div id="container-wrap">
         	<Sidebar></Sidebar>
				<div id="colorlib-main">
					<Introduction></Introduction>
					<About></About>
					<Testtools></Testtools>
					<Robot></Robot>
          	</div>
      	</div>
      </div>
    );
  }
}

export default App;
